import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { profileData } from '../data/profileData';
import '../styles/Skills.css';

function Skills() {
  return (
    <Container className="py-5 min-vh-100 d-flex flex-column justify-content-center">
      <h2 className="text-center mb-5 display-5 fw-bold" data-aos="fade-up">
        TechStack & Tools
      </h2>
      
      <Card className="p-4 shadow border-0 rounded-4 skills-card">
        <Row className="justify-content-center g-4">
          {profileData.skills.map((skill, index) => (
            <Col 
              key={index} 
              xs={6} sm={4} md={3} lg={2} 
              className="d-flex flex-column align-items-center skill-item"
            >
              <div 
                className="skill-icon-wrapper p-3 rounded-circle bg-light mb-3"
                style={{ transition: 'transform 0.3s ease' }}
              >
                {skill.icon}
              </div>
              <h6 className="fw-bold text-secondary">{skill.name}</h6>
            </Col>
          ))}
        </Row>
      </Card>
    </Container>
  );
}

export default Skills;